<script lang="ts">
import { defineComponent } from "vue";

const baseIcons: Record<string, string> = import.meta.glob(
  "@/assets/icons/**/*.svg",
  { eager: true, query: "?url", import: "default" }
);

const variantIcons: Record<string, string> = import.meta.glob(
  "@variant/assets/icons/**/*.svg",
  { eager: true, query: "?url", import: "default" }
);

function extractKey(path: string): string {
  const match = path.match(/\/icons\/(.+)\.svg$/);
  return match ? match[1] : "";
}

// Build lookup map: variant icons override base icons
const icons: Record<string, string> = {};
for (const [path, url] of Object.entries(baseIcons)) {
  icons[extractKey(path)] = url;
}
for (const [path, url] of Object.entries(variantIcons)) {
  icons[extractKey(path)] = url;
}

export default defineComponent({
  props: {
    name: {
      required: true,
      type: String,
    },
    folder: {
      type: String,
      default: "",
    },
  },
  computed: {
    url() {
      const key = this.folder ? `${this.folder}/${this.name}` : this.name;
      return icons[key] ?? "";
    },
  },
});
</script>

<template>
  <img :src="url" :alt="`icon-${name}`" />
</template>
